import React, { useState, useMemo, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
faSort,
faSortUp,
faSortDown,
faEllipsisVertical,
faEye,
faCheckCircle,
faTrash,
faSearch
} from '@fortawesome/free-solid-svg-icons';
import { Dropdown, Form } from 'react-bootstrap';
import FiltersDropdown from './FilterDropDown';
import ApplicationModal from '../ApplicationCard/ApplicationModal';

import '../QueueFull/cabinet-zdo-requests.css';
import './applications-style.css';

// Импортируем API функцию и хелпер
import { getRequestsList } from '../../../../statistic_public/actions';
import { requestword } from '../../../../../components/helpers/wordsnumber';

const ApplicationsList = ({mode}) => {
const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
const [activeMenuIndex, setActiveMenuIndex] = useState(null);
const [page, setPage] = useState(0);
const [pageSize, setPageSize] = useState(10);
const [search, setSearch] = useState('');
const [activeFilters, setActiveFilters] = useState({
filter_selected_zdo: false,
filter_benefits: false
});
const [applicationsData, setApplicationsData] = useState([]);
const [allcount, setAllCount] = useState(0);
const [isLoad, setLoad] = useState(false);

const [selectedApplication, setSelectedApplication] = useState(null);
const [isModalOpen, setIsModalOpen] = useState(false);

const handleViewApplication = (application) => {
  setSelectedApplication(application);
  setIsModalOpen(true);
};



const timeoutRef = useRef(null);

const columns = [
{
key: 'name',
label: "Ім'я дитини",
sortable: true,
width: '20%'
},
{
key: 'certificate',
label: 'Свідотство',
sortable: true,
width: '15%'
},
{
key: 'submitted',
label: 'Дата заявки',
sortable: true,
width: '15%'
},
{
key: 'sendFrom',
label: 'Надсилати з',
sortable: true,
width: '15%'
},
{
key: 'statusText',
label: 'Статус',
sortable: true,
width: '15%'
},
{
key: 'note',
label: '',
sortable: false,
width: '10%'
},
{
key: 'actions',
label: 'Дії',
sortable: false,
width: '10%'
}
];

// Функция для обновления данных
const updData = async () => {
if (isLoad) return;
setLoad(true);
try {
  const { all_count, data } = await getRequestsList({
    search, 
    page, 
    pageSize, 
    sortBy: sortConfig.key, 
    sortDirection: sortConfig.direction,
    filters: activeFilters
  });

  // Преобразуем данные из API в нужный формат
  const formattedData = data.map(app => ({
    id: app.id,
    name: app.name,
    certificate: app.certificate,
    submitted: app.submitted,
    sendFrom: app.sendFrom,
    status: app.status,
    statusClass: getStatusClass(app.status),
    statusText: app.status, //getStatusText(app.status),
    hasSelectedZDO: app.hasSelectedZDO || false,
    hasBenefits: app.hasBenefits || false,
    note: app.note || ''
  }));

  setApplicationsData(formattedData);
  setAllCount(all_count);
} catch (error) {
  console.error('Помилка при завантаженні заявок:', error);
  setApplicationsData([]);
  setAllCount(0);
} finally {
  setLoad(false);
}

};

// Функции для преобразования статусов
const getStatusClass = (status) => {
const statusMap = {
'new': 'status-new',
'approved': 'status-approved',
'rejected': 'status-rejected',
'pending': 'status-pending',
'processing': 'status-processing'
};
return statusMap[status] || 'status-pending';
};

const getStatusText = (status) => {
const statusMap = {
'new': 'Нова',
'approved': 'Підтверджено',
'rejected': 'Відхилено',
'pending': 'В очікуванні',
'processing': 'В обробці'
};
return statusMap[status] || 'В очікуванні';
};

// Функция сортировки
const handleSort = (key) => {
let direction = 'asc';
if (sortConfig.key === key && sortConfig.direction === 'asc') {
direction = 'desc';
}
setSortConfig({ key, direction });
};

// Обновление данных при изменении параметров
useEffect(() => {
updData();
}, [page, search, pageSize, sortConfig, activeFilters]);

useEffect(() => {
return () => {
if (timeoutRef.current) {
clearTimeout(timeoutRef.current);
}
};
}, []);

const getSortIcon = (columnKey) => {
if (columnKey !== sortConfig.key) return faSort;
return sortConfig.direction === 'asc' ? faSortUp : faSortDown;
};

const handleMenuToggle = (index) => {
setActiveMenuIndex(activeMenuIndex === index ? null : index);
};

const handleMenuClose = () => {
setActiveMenuIndex(null);
};

const handleActionSelect = (actionId, application) => {
if (actionId === 'view') {
    console.log('Перегляд заявки:', application);
    handleViewApplication(application);
    // Логика просмотра заявки
} else if (actionId === 'approve_benefits') {
    console.log('Підтвердити пільгу для:', application);
    // Логика подтверждения льготы
} else if (actionId === 'delete') {
    console.log('Видалити заявку:', application);
    // Логика удаления заявки
}
setActiveMenuIndex(null);
};

const handleSearchChange = (e) => {
const value = e.target.value;
if (timeoutRef.current) {
clearTimeout(timeoutRef.current);
}
timeoutRef.current = setTimeout(() => {
setSearch(value);
setPage(0); // Сбрасываем на первую страницу при поиске
}, 500);
};

// Функция для переключения фильтров
const toggleFilter = (filterName) => {
setActiveFilters(prev => ({
...prev,
[filterName]: !prev[filterName]
}));
setPage(0);
};

// Функция для сброса всех фильтров
const clearAllFilters = () => {
setActiveFilters({
filter_selected_zdo: false,
filter_benefits: false
});
setPage(0);
};

// Получение текста для кнопки фильтров
const getFilterButtonText = () => {
const activeFilterCount = Object.values(activeFilters).filter(Boolean).length;
if (activeFilterCount === 0) {
  return "Фільтри не застосовані";
}

const activeFilterNames = [];
if (activeFilters.filter_selected_zdo) {
  activeFilterNames.push("Обрані ЗДО");
}
if (activeFilters.filter_benefits) {
  activeFilterNames.push("Пільгові");
}

return `Застосовано: ${activeFilterNames.join(", ")}`;

};

// Пагинация
const totalPages = Math.ceil(allcount / pageSize);
const ArrPage = Array.from({ length: totalPages }, (_, i) => i);

const ActionsMenu = ({ onActionSelect, onClose, application, mode }) => {
    const actions = [
        {
            id: 'view',
            label: 'Перегляд',
            icon: faEye
        }
    ];

    if(["edit","advanced"].includes(mode)) actions.push(
        {
            id: 'approve_benefits',
            label: 'Підтвердити пільгу',
            icon: faCheckCircle
        });
    if(["advanced"].includes(mode)) actions.push(
        {
            id: 'delete',
            label: 'Видалити',
            icon: faTrash
        });

    return (
        <div className="actions-dropdown">
            {actions.map((action) => (
            <button
                key={action.id}
                className="dropdown-item d-flex align-items-center gap-2 p-2"
                onClick={() => onActionSelect(action.id, application)}
                style={{
                border: 'none',
                backgroundColor: 'transparent',
                width: '100%',
                textAlign: 'left',
                fontSize: '14px',
                cursor: 'pointer'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            >
                <FontAwesomeIcon 
                icon={action.icon} 
                style={{ 
                    width: '16px', 
                    color: action.id === 'delete' ? '#dc3545' : '#6c757d' 
                }} 
                />
                <span 
                style={{ 
                    color: action.id === 'delete' ? '#dc3545' : '#212529' 
                }}
                >
                {action.label}
                </span>
            </button>
            ))}
            
            <div style={{ borderTop: '1px solid #dee2e6', padding: '8px' }}>
            <button
                className="btn btn-sm btn-outline-secondary w-100"
                onClick={onClose}
                style={{ fontSize: '12px' }}
            >
                Скасувати
            </button>
            </div>
        </div>
    );

};

return (
    <>
    <main className="queuetable-main-content queuetable-page">
    <div className="container-fluid">
    <div className="queuetable-content-wrapper">
    {/* Заголовок страницы */}
    <div className="queuetable-year-bar d-flex justify-content-between align-items-center">
    <div className="d-flex align-items-center gap-3 flex-wrap">
    <span className="queuetable-label text-white-50">Заявки на зарахування</span>
    </div>
    </div>
            {/* Панель управления */}
            <div className="applications-controls">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                {/* Фильтры */}
            <FiltersDropdown 
                    activeFilters={activeFilters}
                    toggleFilter={toggleFilter}
                    clearAllFilters={clearAllFilters}
                    getFilterButtonText={getFilterButtonText}
                />

                {/* Поиск */}
                <div className="search-box">
                <FontAwesomeIcon icon={faSearch} className="search-icon" />
                <Form.Control 
                    type="text" 
                    placeholder="Пошук заявок..." 
                    className="applications-search"
                    onChange={handleSearchChange}
                    disabled={isLoad}
                />
                </div>
            </div>
            </div>

            {/* Таблица */}
            <div className="card applications-table-card">
            <div className="card-body p-0">
                <div className="table-responsive">
                <table className="table applications-table align-middle mb-0">
                    <thead>
                    <tr>
                        {columns.map((column) => (
                        <th 
                            key={column.key}
                            style={{ width: column.width }}
                            onClick={() => column.sortable && handleSort(column.key)}
                        >
                            <div className="d-flex align-items-center">
                            {column.label}
                            {column.sortable && (
                                <FontAwesomeIcon 
                                icon={getSortIcon(column.key)} 
                                className="ms-1" 
                                style={{ fontSize: '12px' }}
                                />
                            )}
                            </div>
                        </th>
                        ))}
                    </tr>
                    </thead>
                    <tbody>
                    {isLoad ? (
                        <tr>
                        <td colSpan={columns.length} className="text-center py-4">
                            <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Завантаження...</span>
                            </div>
                            <p className="mt-2 mb-0">Завантаження заявок...</p>
                        </td>
                        </tr>
                    ) : applicationsData.length > 0 ? (
                        applicationsData.map((application, index) => (
                        <tr key={application.id}>
                            <td>
                            <a 
                                href="#" 
                                className="child-name-link"
                                onClick={(e) => {
                                e.preventDefault();
                                handleActionSelect('view', application);
                                }}
                            >
                                {application.name}
                            </a>
                            </td>
                            <td>{application.certificate}</td>
                            <td>{application.submitted}</td>
                            <td>{application.sendFrom}</td>
                            <td>
                            <span className={`status ${application.statusClass}`}>
                                {application.statusText}
                            </span>
                            </td>
                            <td className={application.note ? 'text-muted' : ''}>
                            {application.note}
                            </td>
                            <td className="text-end">
                            <div className="actions-menu-container" style={{ position: 'relative', display: 'inline-block' }}>
                                <button
                                className="btn btn-sm btn-link text-decoration-none p-0"
                                onClick={() => handleMenuToggle(index)}
                                style={{ color: '#0d6efd' }}
                                disabled={isLoad}
                                >
                                <FontAwesomeIcon icon={faEllipsisVertical} />
                                </button>
                                
                                {activeMenuIndex === index && (
                                <ActionsMenu 
                                    onActionSelect={handleActionSelect}
                                    onClose={handleMenuClose}
                                    application={application}
                                    mode={mode}
                                />
                                )}
                            </div>
                            </td>
                        </tr>
                        ))
                    ) : (
                        <tr>
                        <td colSpan={columns.length} className="text-center py-4">
                            <div className="text-muted">
                            <p className="mb-1">Заявки не знайдено</p>
                            <small>Спробуйте змінити параметри пошуку або фільтри</small>
                            </div>
                        </td>
                        </tr>
                    )}
                    </tbody>
                </table>
                </div>

                {/* Пагинация */}
                <div className="d-flex align-items-center mt-4 applications-pagination-wrapper">
                <div className="applications-pagination-info">
                    Всього {allcount} {requestword(allcount)}
                </div>
                {totalPages > 1 && (
                    <nav aria-label="Page navigation">
                    <ul className="pagination applications-pagination mb-0">
                        <li className="page-item">
                        <button 
                            className="page-link" 
                            aria-label="Previous"
                            onClick={() => setPage(Math.max(0, page - 1))}
                            disabled={page === 0 || isLoad}
                        >
                            <span aria-hidden="true">&lt;</span>
                        </button>
                        </li>
                        {ArrPage.slice(page - (page % 5), page + (5 - page % 5)).map((v) => (
                        <li 
                            key={v} 
                            className={`page-item ${v === page ? 'active' : ''}`}
                        >
                            <button 
                            className="page-link"
                            onClick={() => setPage(v)}
                            disabled={isLoad}
                            >
                            {v + 1}
                            </button>
                        </li>
                        ))}
                        <li className="page-item">
                        <button 
                            className="page-link" 
                            aria-label="Next"
                            onClick={() => setPage(Math.min(totalPages - 1, page + 1))}
                            disabled={page === totalPages - 1 || isLoad}
                        >
                            <span aria-hidden="true">&gt;</span>
                        </button>
                        </li>
                    </ul>
                    </nav>
                )}
                </div>
            </div>
            </div>
        </div>
        </div>
    </main>
        <ApplicationModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            applicationId={selectedApplication?.id}
            mode={mode}
        />
    </>

    );  
};

export default ApplicationsList;